<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{path:'/dashboard'}">Inicio</router-link>
                            </li>
                            <li class="breadcrumb-item" aria-current="page" v-if="type==='admin'">
                                <router-link :to="{path:'/admin/grupos'}">Grupos</router-link>
                            </li>
                            <li class="breadcrumb-item" aria-current="page" v-if="type==='admin'"
                                style="text-transform: capitalize">
                                <router-link :to="{path:'/admin/grupos/'+sede}">{{ sede }}</router-link>
                            </li>
                            <li class="breadcrumb-item" aria-current="page" v-if="type==='admin'"
                                style="text-transform: capitalize">
                                <router-link :to="{path:'/admin/grupos/'+sede+'/'+dia}">{{ dia }}</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">{{ horaId }}
                            </li>
                        </ol>
                    </nav>
                </div>


                <div class="col-md-12" style="margin-bottom: 20px">

                    <h2>Jugadores
                        <router-link :to="{path:'/admin/pagos/'+sede+'/'+dia+'/'+horaId}">
                            <button class="btn btn-success btn-sm">Ver pagos</button>
                        </router-link>
                    </h2>

                    <div class="card">
                        <div class="table-responsive">
                            <table class="table table-striped text-nowrap" id="table-players">
                                <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Posición</th>
                                    <th>Modalidad</th>
                                    <th>Año de Nacimiento</th>
                                    <th>Club</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="player in hora.players">
                                    <th>
                                        <div class="media align-items-center">

                                            <img alt="Image placeholder" :src="player.img"
                                                 class="avatar rounded-circle mr-3">

                                            <div class="media-body">
                                                <router-link :to="{path: '/jugadores/'+player.id}">
                                                    <span class="name mb-0 text-sm"
                                                          id="name-player">{{
                                                            player.apellidos | capitalizeText
                                                        }}, {{ player.nombre | capitalizeText }}</span>
                                                    <span class="text-danger"
                                                          v-if="player.reserva === 1"> (RESERVA)</span>
                                                </router-link>
                                            </div>
                                        </div>

                                    </th>
                                    <td class="align-middle">{{ player.posicion }}</td>
                                    <td class="align-middle">{{ player.modalidad | parseModalidad }}</td>
                                    <td class="align-middle">
                                        {{ player.year | parseDate }}
                                    </td>
                                    <td class="align-middle">
                                        {{ player.club }}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal :show.sync="modalSendMail">
            <template slot="header">
                <h4 class="modal-title" id="exampleModalLabel">Enviar correo a grupo</h4>
            </template>
            <div>
                <div class="row">
                    <div class="col-md-12" style="margin-bottom: 20px">
                        <label><strong>Asunto</strong></label>
                        <input type="text" class="form-control" v-model="mail.asunto">
                    </div>

                    <div class="col-md-12" style="margin-bottom: 20px">
                        <label><strong>Mensaje</strong></label>
                        <textarea id="" cols="30" rows="10" class="form-control" v-model="mail.mensaje"></textarea>
                    </div>

                </div>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="modalSendMail = false">Cerrar</base-button>
                <base-button type="primary" @click="sendMail">Enviar</base-button>
            </template>
        </modal>
    </div>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert2'
import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'


export default {
    data() {
        return {
            sede: this.$route.params.sede,
            dia: this.$route.params.dia,
            turno: this.$route.params.turno,
            horaId: this.$route.params.id,
            modalSendMail: false,
            modalEditGroup: false,
            hora: {},
            groupEdit: {},
            type: this.$store.getters.type,
            mail: {
                asunto: "",
                mensaje: ""
            }
        };
    },
    directives: {
        'b-tooltip': BTooltipDirective
    },
    created() {
        this.loadGroup();
    },
    methods: {
        loadGroup() {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'horas/' + this.$route.params.id, {
                params: {
                    sede: vm.sede,
                    dia: vm.dia,
                    jwt: vm.$store.getters.jwt,
                    season: vm.$store.getters.season
                }
            }).then(response => {
                if (response.data.response) {
                    vm.hora = response.data.result;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        editGroup() {
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'groups/' + vm.groupEdit.id, {
                groupEdit: vm.groupEdit,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    vm.modalEditGroup = false;
                    vm.loadGroup();
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        sendMail() {
            if (this.mail.asunto === "") {
                swal({
                    title: 'Atención',
                    text: "Debes rellenar el asunto",
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
                return;
            }

            if (this.mail.mensaje === "") {
                swal({
                    title: 'Atención',
                    text: "Debes rellenar el mensaje",
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
                return;
            }

            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'groups/' + this.$route.params.id + '/sendMail', {
                mail: vm.mail,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    vm.modalSendMail = false;
                    swal({
                        title: 'Atención',
                        text: "Mensaje enviado correctamente",
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'success'
                    });
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
    }

};
</script>
<style scoped>

.container-fluid {
    margin-top: 39px;
}

.card {
    background-color: #f7fafc !important;
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.30) !important;
    border: 1px solid rgba(0, 0, 0, .05);
    border-radius: .375rem;
}

#table-players tbody tr:hover {
    background-color: rgba(62, 92, 75, 0.3);
}

#table-players tbody tr:hover #name-player {
    text-decoration: underline;
}


</style>
